import { useEffect } from "react";
import { Box, Container, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import CustomRightImage from "@components/CustomRightImagev2";
import { InactivityHandler } from "@components/InactivityHandler";
import { RootState, useAppDispatch } from "@store/store";
import { useSelector } from "react-redux";
import { useLazyGetLoanApplicationByIdQuery } from "@api/applications";
import { useNavigate } from "react-router-dom";
import IconSandClock from "@components/Images/IconSandClock";
import useInterval from "@hooks/useInterval";
import { setLoanStatus } from "@store/slices/registerSlice";

const SCREEN_STATUS = "CSBEX";
const SECONDS_TO_FETCH = 10;

const RevisandoExpedientePF = () => {
  // hooks
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // redux hooks
  const application = useSelector((state: RootState) => state.register.application);

  // api hooks
  const [getLoanApplicationById] = useLazyGetLoanApplicationByIdQuery();

  const loanInterval = useInterval(async () => {
    try {
      const loan_application = await getLoanApplicationById(application.id).unwrap();
      if (loan_application.status_catalog?.code !== SCREEN_STATUS) {
        if (loan_application.status_catalog?.code && loan_application.status_catalog?.url_actual) {
          dispatch(setLoanStatus(loan_application.status_catalog?.code));
          navigate(loan_application.status_catalog?.url_actual);
        }
      }
    } catch (error) {
      console.error("Ha ocurrido un error al obtener la aplicación");
    }
  }, SECONDS_TO_FETCH);

  useEffect(() => {
    loanInterval.setIsActiveInterval(true);

    return () => {
      loanInterval.setIsActiveInterval(false);
    };
  }, [loanInterval]);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <InactivityHandler />
        <Box
          sx={{
            mt: 2,
            mx: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant={"tofu_title"} textAlign="center" color={"primary.dark"}>
            Revisando Expediente y Preparando documentos contractuales
          </Typography>

          <Container maxWidth="sm" sx={{ mt: isMobileOrTablet ? 3 : 4, textAlign: "center" }}>
            <Typography
              sx={{ color: "primary.dark", mb: 1 }}
              variant={isMobileOrTablet ? "body2" : "body1"}
              textAlign="center"
              fontWeight={500}
            >
              Validaremos tu expediente y prepararemos los documentos para firma, volveremos contigo a la brevedad.
            </Typography>

            <Box mt={isMobileOrTablet ? 2 : 4} display="flex" justifyContent="center">
              <IconSandClock width={isMobileOrTablet ? "100" : "150"} fill={theme.palette.primary.dark} />
            </Box>

            <Typography
              sx={{ color: "primary.dark", mt: isMobileOrTablet ? 2 : 4 }}
              variant={isMobileOrTablet ? "body2" : "body1"}
              textAlign="center"
              fontWeight={500}
            >
              ¡Despreocúpate!
              <br />
              Puedes salir de esta pantalla, tan pronto tu visita se encuentre validada, y tus documentos listos para
              firma, te contactaremos via Whatsapp
            </Typography>
          </Container>
        </Box>
      </Grid>

      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default RevisandoExpedientePF;
